import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from '../app.service';
import { AppSettings } from '../app.settings';
import { User } from '../models/user';
import { AuthenticationService } from '../services/AuthenticationService';

@Component({ standalone:false,
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent {
 
 
  private authenticatedSubscription: Subscription;

  constructor(public appSettings:AppSettings, public appService:AppService, private router:Router, private authService:AuthenticationService) {
    this.authenticatedSubscription=this.authService.authenticatedSubject.subscribe(u=>this.processAuthenticated(u));
  }
  
  get settings(){
    return this.appSettings.settings;  
  }

  private processAuthenticated(u:User|undefined){
    if(u){
      this.router.navigate(['/home']);
    }
    else{
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy(): void {
    if(this.authenticatedSubscription) this.authenticatedSubscription.unsubscribe();
  }

}
